import React from 'react';
import { TbArrowBigLeftLines, TbArrowBigRightLines } from 'react-icons/tb';

interface NavigateToCategoryArrowsProps {
    show: boolean;
    index: number;
    categoryPrevName: string;
    categoryNextName: string;
    showPrev: boolean;
    showNext: boolean;
    onClickCategory?: CallableFunction;
}

const NavigateToCategoryArrows = ({
    show,
    index,
    categoryPrevName,
    categoryNextName,
    showPrev,
    showNext,
    onClickCategory = () => {},
}: NavigateToCategoryArrowsProps) => {
    if (!show) return null;
    return (
        <section className='col-span-full py-6'>
        <div className='flex justify-between'>
            {showPrev && 
                <div className='flex flex-col items-center gap-1 justify-center w-full' onClick={() => onClickCategory(index - 1)}>
                    <div className='flex text-sm text-center items-center gap-0.5 leading-4 text-gray-400'>
                        <TbArrowBigLeftLines className="animate-drag-left" />
                        <span className='font-bold'>{categoryPrevName}</span>
                    </div>
                </div>
            }

            {showNext && 
                <div className='flex flex-col items-center gap-1 justify-center w-full' onClick={() => onClickCategory(index + 1)}>
                    <div className='flex text-sm text-center items-center gap-0.5 leading-4 text-gray-400'>
                        <span className='font-bold'>{categoryNextName}</span>
                        <TbArrowBigRightLines className="animate-drag-right" />
                    </div>
                </div>
            }
        </div>
    </section>
    )
}

export default NavigateToCategoryArrows;